<template>
    <div
            id="printMe"
            class="prt-wrapper">
        <h2 class="x-center">昆明理工大学科研业绩表</h2>
        <p class="x-single-line x-small">
          <span style="margin-right: 1em">
            姓名：{{tblData.name}}({{tblData.number}})
          </span>
            <span style="margin-right: 1em">
            职称：{{tblData.titleName}}
          </span>
            <span style="margin-right: 1em">
            部门：{{tblData.deptName}}
          </span>
            <span>
            起止日期：{{tblData.startDate}} 至 {{tblData.endDate}}
          </span>
        </p>
        <table
                v-if="tblVisable.includes('project')"
                class="x-small">
            <thead>
            <tr>
                <th colspan="7" class="x-center">项目</th>
            </tr>
            <tr>
                <th style="width: 3em;" class="x-center">#</th>
                <th>项目名称</th>
                <th style="width: 9em;">项目类别</th>
                <th style="width: 5.5em;">参研次序</th>
                <th style="width: 6.5em;">开始日期</th>
                <th style="width: 6.5em;">结束日期</th>
                <th style="width: 9.5em;" class="x-right">合同/实到经费(元)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in tblData.projects" :key="row.dbid">
                <td class="x-center">{{ idx + 1 }}</td>
                <td>
          <span
                  style="font-weight: bold"
                  v-text="`[${row.projState.name}]`"></span>
                    {{ row.name }}
                </td>
                <td>{{ row.type.name }}</td>
                <td>
                    {{ row.userRank }}
<!--                    <span v-if="tblData.userId === row.leaderId">主持</span>-->
<!--                    <span v-else>第{{ row.member.rank }}位</span>-->
                </td>
                <td>{{ row.startDate }}</td>
                <td>{{ row.finishDate }}</td>
                <td class="x-right">
                    {{ (row.contractAmounts || 0 )| currency }}
                    <br/>
                    {{ (row.income || 0 )| currency }}
                </td>
            </tr>

            </tbody>
        </table>

        <table
                v-if="tblVisable.includes('paper')"
                class="x-small" style="margin-top: 1em">
            <thead>
            <tr>
                <th colspan="7" class="x-center">论文</th>
            </tr>
            <tr>
                <th style="width: 3em;" class="x-center">#</th>
                <th>论文标题</th>
                <th style="min-width: 9em;">期刊/会议名称</th>
                <th style="width: 6.5em;">发表日期</th>
                <th style="width: 7.5em;">论文类别</th>
                <th style="width: 10em;">论文作者</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in tblData.papers" :key="row.dbid">
                <td class="x-center">{{ idx + 1 }}</td>
                <td>
                    {{ row.title }}
                </td>
                <td>{{ row.publication }}</td>
                <td>{{ row.publDate }}</td>
                <td v-if="row.category == 'J'">期刊论文 {{(row.indexings || []).map( v => v.name).join(',')}}
                    {{row.level.name}}
                </td>
                <td v-else>会议论文 {{(row.indexings || []).map( v => v.name).join(',')}}</td>
                <td>{{ row.authorNames}}</td>
                <!--<td>{{ fmtPaperAuthors(row.authors) }}</td>-->
            </tr>
            </tbody>
        </table>

        <table
                v-if="tblVisable.includes('book')"
                class="x-small" style="margin-top: 1em">
            <thead>
            <tr>
                <th colspan="7" class="x-center">论著</th>
            </tr>
            <tr>
                <th style="width: 3em;" class="x-center">#</th>
                <th>论著名称</th>
                <th style="min-width: 10em;">出版单位</th>
                <th style="width: 6.5em;">出版时间</th>
                <th style="width: 6.5em;">类型</th>
                <th style="width: 14em;">论著作者</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in tblData.books" :key="row.dbid">
                <td class="x-center">{{ idx + 1 }}</td>
                <td>
                    {{ row.name }}
                </td>
                <td>{{ row.publisher }}</td>
                <td>{{ row.publDate }}</td>
                <td>{{ row.type.name }}</td>
                <td>{{ row.authorNames}}</td>
<!--            <td>{{ fmtBookAuthors(row.authors)}}</td>-->
            </tr>
            </tbody>
        </table>

        <table
                v-if="tblVisable.includes('award')"
                class="x-small" style="margin-top: 1em">
            <thead>
            <tr>
                <th colspan="7" class="x-center">奖励</th>
            </tr>
            <tr>
                <th style="width: 3em;" class="x-center">#</th>
                <th>获奖内容</th>
                <th style="min-width: 10em;">奖励类别</th>
                <th style="width: 6.5em;">获奖时间</th>
                <th style="width: 14em;">获奖人员</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in tblData.awards" :key="row.dbid">
                <td class="x-center">{{ idx + 1 }}</td>
                <td>
                    {{ row.achievement }}
                </td>
                <td>{{ row.name }}<br/>{{ row.level.name }} {{ row.grade.name }}</td>
                <td>{{ row.grantDate }}</td>
                <td>{{ row.awardees.map(a => `(${a.rank})${a.name}`).join(",") }}</td>
            </tr>
            </tbody>
        </table>

        <table
                v-if="tblVisable.includes('property')"
                class="x-small" style="margin-top: 1em">
            <thead>
            <tr>
                <th colspan="8" class="x-center">知识产权</th>
            </tr>
            <tr>
                <th style="width: 3em;" class="x-center">#</th>
                <th>名称</th>
                <th style="min-width: 6em;">类别</th>
                <th style="width: 6.5em;">申请号</th>
                <th style="width: 6.5em;">申请时间</th>
                <th style="width: 6.5em;">授权时间</th>
<!--                <th style="width: 6.5em;">归属部门</th>-->
                <th style="width: 14em;">参与人员</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in tblData.inteProperties" :key="row.dbid">
                <td class="x-center">{{ idx + 1 }}</td>
                <td>{{ row.name }}</td>
                <td>{{ row.type ? row.type.name : " " }}</td>
                <td>{{ row.number }}</td>
                <td>{{ row.appDate }}</td>
                <td>{{ row.authoredDate }}</td>
<!--                <td>{{ row.department ? row.department.name : " "}}</td>-->
                <td>{{ row.persons.map(a => `(${a.order})${a.name}`).join(",") }}</td>
            </tr>
            </tbody>
        </table>

      <table
          v-if="tblVisable.includes('achivement')"
          class="x-small" style="margin-top: 1em">
        <thead>
        <tr>
          <th colspan="8" class="x-center">人文社科应用成果</th>
        </tr>
        <tr>
          <th style="width: 3em;" class="x-center">#</th>
          <th>成果</th>
          <th style="min-width: 7em;">形式</th>
          <th style="width: 5.5em;">认定标准</th>
          <th style="width: 5em;">参研次序</th>
          <th style="width: 10.5em;">鉴定/采用时间</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, idx) in tblData.achivement" :key="row.dbid">
          <td class="x-center">{{ idx + 1 }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.type ? row.type.name : " " }}</td>
          <td class="x-center">{{ row.stand ? row.stand.name : " " }}</td>
          <td>{{ row.userRank }}</td>
          <td class="x-center">{{ row.grantDate }}</td>
        </tr>
        </tbody>
      </table>


        <p v-if="adminDept"
           class="x-single-line x-small x-right"
           style="margin: 2em 1em 1em 1em">{{deptName}}(签章)</p>
        <p class="x-single-line x-small x-right"
           style="margin: 2em 1em 1em 1em">{{tblData.date}}</p>
    </div>

</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: ["tblData", "tblVisable", "adminDept"],
        data() {
            return {}
        },
        computed: {
            ...mapGetters(['deptName'])
        },
        methods: {
            fmtPaperAuthors(authors) {
                return authors
                    .map(a => `(${a.corresponding ? '通讯,' : ''}${a.rank})${a.name}`)
                    .join(",")
            },
            fmtBookAuthors(authors) {
                return authors
                    .map(a => `(${a.typeId ? a.typeName + "," : ''}${a.rank})${a.name}`)
                    .join(",")
            }
        }
    }
</script>

